import adventures_of_huckleberry from './img/adventures_of_huckleberry.jpg'
import around_the_World from './img/around_the_World.jpg'
import captains_courageous from './img/captains_courageous.jpg'
import children_of_the_comet from './img/children_of_the_comet.jpg'
import congo from './img/congo.jpg'
import gullivers_travels from './img/gullivers_travels.jpg'
import hatchet from './img/hatchet.jpg'
import into_the_wild from './img/into_the_wild.jpg'
import king_solomon from './img/king_solomon.jpg'
import master_and_commander from './img/master_and_commander.jpg'
import moby_dick from './img/moby_dick.jpg'
import odyssey_homer from './img/odyssey_homer.jpg'
import sahara from './img/sahara.jpg'
import shantaram from './img/shantaram.jpg'
import sharpe_tiger from './img/sharpe_tiger.jpg'
import stardust from './img/stardust.jpg'
import tarzan from './img/tarzan.jpg'
import the_call_of_the_wild from './img/the_call_of_the_wild.jpg'
import the_cruel_sea from './img/the_cruel_sea.jpg'
import the_mysterious_island from './img/the_mysterious_island.jpg'
import the_riddle_of_the_sands from './img/the_riddle_of_the_sands.jpg'
import the_swiss_family from './img/the_swiss_family.jpg'
import the_three_musketers from './img/the_three_musketers.jpg'
import treasure_island from './img/treasure_island.jpg'


export const ADBookItems = [
  {
    id:1301,
    title:"Adventures of Huckleberry Finn",
    image: adventures_of_huckleberry,
    price:399,
    
  },
  {
    id:1302,
    title:"Around the World in Eighty Days",
    image: around_the_World,
    price:149,
    
  },
  {
    id:1303,
    title:"Captains Courageous",
    image: captains_courageous,
    price:99,
    
  },
  {
    id:1304,
    title:"Children of the Comet",
    image: children_of_the_comet,
    price:1249,
    
  },
  {
    id:1305,
    title:"Congo",
    image: congo,
    price:2279,
    
  },
  {
    id:1306,
    title:"Gulliver's Travels",
    image: gullivers_travels,
    price:199,
    
  },
  {
    id:1307,
    title:"Hatchet",
    image: hatchet,
    price:1099,
    
  },
  {
    id:1308,
    title:"Into the Wild",
    image: into_the_wild,
    price:1139,
    
  },
  {
    id:1309,
    title:"King Solomon's Mines",
    image: king_solomon,
    price:399,
    
  },
  {
    id:1310,
    title:"Master & Commander",
    image: master_and_commander,
    price:3449,
    
  },
  {
    id:1311,
    title:"Moby Dick",
    image: moby_dick,
    price:999,
    
  },
  {
    id:1312,
    title:"Odyssey Homer",
    image: odyssey_homer,
    price:399,
    
  },
  {
    id:1313,
    price:299,
    title: "Sahara",
    image: sahara,
    
  },
  {
    id:1314,
    price:499,
    title: "Shantaram",
    image: shantaram,
   
  },
  {id:1315,
    price:399,
    title: "Sharpe's Tiger",
    image: sharpe_tiger,
    
  },
  {
    id:1316,
    price:799,
    title: "Star Dust",
    image: stardust,
    
  },
  {
    id:1317,
    price:1349,
    title: "Tarzan of the Apes",
    image: tarzan,
    
  },
  {
    id:1318,
    price:99,
    title: "The Call of the Wild",
    image: the_call_of_the_wild,
    
  },
  {
    id:1319,
    price:2999,
    title: "The Cruel Sea",
    image: the_cruel_sea,
    
  },
  {
    id:1320,
    price:399,
    title: "The Mysterious Island",
    image: the_mysterious_island,
    
  },
  {
    id:1321,
    price:259,
    title: "The Riddle of the Sands",
    image: the_riddle_of_the_sands,
    
  },
  {
    id:1322,
    price:499,
    title: "The Swiss Family Robinson",
    image:the_swiss_family,    
  },
  {
    id:1323,
    price:259,
    title: "The Three Musketers",
    image: the_three_musketers,
    
  },
  {
    id:1324,
    price:199,
    title: "Treasure Island",
    image: treasure_island,
    
  },
  
];